// extracted by mini-css-extract-plugin
module.exports = {"label":"ScoreStrategyView_label__3GzWK","field":"ScoreStrategyView_field__34uSk","select":"ScoreStrategyView_select__2BKRc","suffix":"ScoreStrategyView_suffix__1OLu0"};